import React, { Fragment } from 'react';
import axios from 'axios';
import baseApi from '../../api';
import { useState } from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Dashboard from '../../Admin/Dashboard/Dashboard';
import dateFormat from 'dateformat';
import Loader from '../../Admin/Dashboard/Loader';
const logo = '/static/img/blog-logo.png';

export default function CSdetails() {
  const [caseStudyDetails, setCaseStudyDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let pathname = window.location.pathname.toString();
    pathname = pathname.split('/');
    pathname = pathname[pathname.length - 1];

    if (pathname) {
      axios
        .get(baseApi + 'case-study/get-case-study/' + pathname)
        .then((res) => {
          setCaseStudyDetails({
            b_title: res.data.data.b_title,
            b_description: res.data.data.b_description,
            page_title: res.data.data.page_title,
            page_description: res.data.data.page_description,
            keyword: res.data.data.keyword,
            image: res.data.data.image,
            slug: res.data.data.slug,
            createdAt: res.data.data.createdAt
          });
          setLoading(false);
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    document.title = caseStudyDetails.b_title;
  }, []);

  const image = caseStudyDetails.image;

  return (
    <Fragment>
      {!loading ? (
        <div className="admin_panel">
          <Helmet>
            <title>{`${caseStudyDetails.b_title}`} | Dean Infotech Pvt. Ltd.</title>
            <meta id="meta-description" name="description" content={`${caseStudyDetails.b_description}`} />
            <meta id="og-keywords" name="keywords" property="og:keywords" content={`${caseStudyDetails.keyword}`} />
            <meta id="og-title" property="og:title" content={`${caseStudyDetails.b_title}`} />
          </Helmet>
          <Dashboard />

          <div className="container">
            <div className="col-sm-12">
              <div className="card">
                <h2>{caseStudyDetails.b_title}</h2>
                <h5>
                  <img src={logo} alt="Dean Infotech" className="logo_blog" />
                  Dean Infotech{' '}
                  <span>
                    <i className="fa fa-calendar" aria-hidden="true"></i> {dateFormat(caseStudyDetails.createdAt, 'fullDate')}
                  </span>
                </h5>
                <div className="blog_img blog-img">
                  <img src={image} alt="" className="blog1" />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: caseStudyDetails.b_description
                  }}
                  className="for_description_div"
                ></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </Fragment>
  );
}
